<uilab-mat-chip
    class="mat-mdc-chip--outlined lozenge"
    [class.lozenge--success]="status === 'success'"
    [class.lozenge--warning]="status === 'warning'"
    [class.lozenge--error]="status === 'error'"
    [class.lozenge--information]="status === 'information'"
    [disableRipple]="true"
>
    <ng-content></ng-content>
</uilab-mat-chip>
